const CASE_MODAL = 'CASE_MODAL'
const PROMO_CODE_MODAL = 'PROMO_CODE_MODAL'
const REFERRAL_WELCOME_MODAL = 'REFERRAL_WELCOME_MODAL'
const CONFIRM_MODAL = 'CONFIRM_MODAL'
const GAME_SELECT_MODAL = 'GAME_SELECT_MODAL'
const CASE_REWARD_MODAL = 'CASE_REWARD_MODAL'
const SITE_ID_HELP_MODAL = 'SITE_ID_HELP_MODAL'
const LEADERBOARD_REWARD_MODAL = 'LEADERBOARD_REWARD_MODAL'

export const modalNames = {
    CASE_MODAL,
    PROMO_CODE_MODAL,
    REFERRAL_WELCOME_MODAL,
    CONFIRM_MODAL,
    GAME_SELECT_MODAL,
    CASE_REWARD_MODAL,
    SITE_ID_HELP_MODAL,
    LEADERBOARD_REWARD_MODAL,
}
